"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenizePaymentCard = exports.tokenizePaymentBankUs = exports.tokenizePaymentBankCanada = void 0;
var uuid_1 = require("uuid");
function tokenizePaymentBankCanada(bankNumber, transitNumber, accountNumber, accountType, processId, relayUrl, gatewayId, contact, address) {
    var newPaymentId = uuid_1.v4();
    var streetAddress = address.address1;
    if (address.address2) {
        streetAddress += '\n' + address.address2;
    }
    var payload = {
        IATS_DPM_ProcessOption: 'TOKEN',
        IATS_DPM_RecurringOn: 'FALSE',
        IATS_DPM_ProcessID: processId,
        IATS_DPM_RelayURL: relayUrl,
        IATS_DPM_ClientDefined_PaymentId: newPaymentId,
        IATS_DPM_ClientDefined_GatewayId: gatewayId,
        IATS_DPM_Title: contact.salutation,
        IATS_DPM_FirstName: contact.firstName,
        IATS_DPM_LastName: contact.lastName,
        IATS_DPM_Address: streetAddress,
        IATS_DPM_City: address.city,
        IATS_DPM_Province: address.state,
        IATS_DPM_Country: address.country,
        IATS_DPM_ZipCode: address.zip,
        IATS_DPM_Phone: contact.primaryPhone,
        IATS_DPM_EMAIL: contact.email,
        IATS_DPM_AccountNumber: bankNumber + transitNumber + accountNumber,
        IATS_DPM_MOP: 'ACHEFT',
        IATS_DPM_AccountType: accountType,
    };
    var formData = new FormData();
    for (var _i = 0, _a = Object.entries(payload); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        formData.append(key, value);
    }
    return fetch('https://www.iatspayments.com/netgate/IATSDPMProcess.aspx', {
        method: 'POST',
        mode: 'no-cors',
        body: formData,
    }).then(function (response) {
        return response.text().then(function () {
            return newPaymentId;
        });
    });
}
exports.tokenizePaymentBankCanada = tokenizePaymentBankCanada;
function tokenizePaymentBankUs() {
    throw new Error('US Bank Tokenization Not Yet Implemented');
}
exports.tokenizePaymentBankUs = tokenizePaymentBankUs;
function tokenizePaymentCard() {
    throw new Error('Card Tokenization Not Yet Implemented');
}
exports.tokenizePaymentCard = tokenizePaymentCard;
